module.exports = __webpack_public_path__ + "static/media/aim.f63046f0.svg";